// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Meta
 */
export interface Meta {
    /**
     * Total number of items
     */
    total?: number;
    /**
     * Current page number
     */
    page?: number;
    /**
     * Items per page
     */
    perPage?: number;
}

/**
 * Check if a given object implements the Meta interface.
 */
export function instanceOfMeta(value: object): value is Meta {
    return true;
}

export function MetaFromJSON(json: any): Meta {
    return MetaFromJSONTyped(json, false);
}

export function MetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): Meta {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'perPage': json['perPage'] == null ? undefined : json['perPage'],
    };
}

export function MetaToJSON(json: any): Meta {
    return MetaToJSONTyped(json, false);
}

export function MetaToJSONTyped(value?: Meta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'page': value['page'],
        'perPage': value['perPage'],
    };
}

